import { useEffect } from "react";
import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";
import { UPDATE_CYLINDER_SETUP } from "../../../api/allApi_List";
import spin from "../../../assets/icons/spin.png";
import useGetData from "../../../CustomHooks/useAxios/useGetData";
import UpdateCylinderForm from "../forms/UpdateCylinderForm";

const UpdateCylinderPage = () => {
  const { data, isLoaded, error, getData } = useGetData();

  useEffect(() => {
    getData(UPDATE_CYLINDER_SETUP);
  }, []);

  return (
    <MainPageLayout headerConfig={{ title: "Update Cylinder" }}>
      {isLoaded && !error ? (
        <UpdateCylinderForm setupData={data} />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading..." animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default UpdateCylinderPage;
